module.exports = __webpack_public_path__ + "static/media/icone_advertencia.953b9bdb.svg";